"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spookyswap = void 0;
exports.spookyswap = {
    router: "0xF491e7B69E4244ad4002BC14e878a34207E38c29",
    masterchef: "0x2b2929E785374c651a81A63878Ab22742656DcDd",
};
